<template lang="pug">
div.row
    div.col-sm-12
        h5 {{ currency }} {{ `${totalAmountFormatted}` }}
        small.block {{ outlet.name }}
        small.block {{ receiptDateFormat(receipt.settled_date) }}
        small.block {{ receiptNumberFormat(receipt) }}

    div.col-sm-12
        hr

    div.col-sm-12
        div.row
            div.col-xs-5
                small.pull-left Table
                br
                h5.pull-left {{ hasTable && table ? table.name : 'TAKEAWAY'  }}
            div.col-xs-3
                small.pull-left Pax
                br
                h5.pull-left {{ hasTable ? orderTable.pax : 'N/A' }}
            div.col-xs-4
                small.pull-left Cashier
                br
                h5.pull-left {{ cashier.name }}

    div.col-sm-12
        hr

    div.col-sm-12
        div.row
            div.col-xs-6
                small.pull-left Customer
                br
                h5(style="font-size: 18px;" v-for="(customer, index) in order.customers" :key="index") {{ customer.name }}
                
                h5(style="font-size: 18px;").pull-left(v-if="!order.customers.length") Guest
            div.col-xs-6
                small.pull-left Phone Number
                br
                h5(style="font-size: 18px;" v-for="(customer, index) in order.customers" :key="index") {{ customer.phone ? customer.phone : '-'}}

                h5(style="font-size: 18px;").pull-left(v-if="!order.customers.length") -
        div.row
            div.col-xs-12
                small.pull-left Email
                br
                h5(style="font-size: 18px;" v-for="(customer, index) in order.customers" :key="index") {{ customer.email ? customer.email : '-'}}

                h5(style="font-size: 18px;").pull-left(v-if="!order.customers.length") -
    div.col-sm-12
        hr
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import numeral from 'numeral';
import { mapGetters, mapActions } from 'vuex';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'outlet',
            'table',
            'orderTable',
            'cashier',
            'hasTable',
            'order',
            'currency',
            'totalAmountFormatted',
        ]),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/details.vue